import { BillViewOptionGroup } from "../../types/bill";
import { InvoiceViewOptionGroup } from "../../types/invoice";
import { WorkspaceTimezone } from "../../workspaceTimezone";
import { toUTCDateOnly, toWorkspaceDateSafe } from "../date";

export const BILL_EXPORT_SHAPE_LABELS = {
    [BillViewOptionGroup.BILL]: "Bills",
    [BillViewOptionGroup.LINE_ITEMS]: "Bill line items",
    [BillViewOptionGroup.COUNTERPARTY]: "Bills by vendor",
} as const satisfies Record<BillViewOptionGroup, string>;

export const INVOICE_EXPORT_SHAPE_LABELS = {
    [InvoiceViewOptionGroup.INVOICE]: "Invoices",
    [InvoiceViewOptionGroup.LINE_ITEMS]: "Invoice line items",
    [InvoiceViewOptionGroup.COUNTERPARTY]: "Invoices by customer",
} as const satisfies Record<InvoiceViewOptionGroup, string>;

interface WorkspaceExportDateParams {
    timezone: WorkspaceTimezone;
    now?: Date;
}

interface WorkspaceListExportFilenameParams {
    workspaceName: string;
    shape: string;
    date: string;
}

interface BillExportFilenameParams {
    workspaceName: string;
    groupBy: BillViewOptionGroup;
    date: string;
}

interface InvoiceExportFilenameParams {
    workspaceName: string;
    groupBy: InvoiceViewOptionGroup;
    date: string;
}

export function getWorkspaceExportDate({
    timezone,
    now = new Date(),
}: WorkspaceExportDateParams): string {
    return toWorkspaceDateSafe({ date: now, timezone }) ?? toUTCDateOnly(now);
}

export function buildWorkspaceListExportFilename({
    workspaceName,
    shape,
    date,
}: WorkspaceListExportFilenameParams): string {
    const parts = [workspaceName.trim(), shape, date].filter(
        (part) => part.length > 0,
    );
    return `${parts.join(" ")}.xlsx`;
}

export function getBillExportFilename({
    workspaceName,
    groupBy,
    date,
}: BillExportFilenameParams): string {
    return buildWorkspaceListExportFilename({
        workspaceName,
        shape: BILL_EXPORT_SHAPE_LABELS[groupBy],
        date,
    });
}

export function getInvoiceExportFilename({
    workspaceName,
    groupBy,
    date,
}: InvoiceExportFilenameParams): string {
    return buildWorkspaceListExportFilename({
        workspaceName,
        shape: INVOICE_EXPORT_SHAPE_LABELS[groupBy],
        date,
    });
}
